/** One path→analytics-surface mapping for both Express and the Ember SPA. */
export function emberPageSurface(path = '/') {
  if (path === '/') return 'landing';
  if (path === '/auth') return 'login';
  if (path === '/talk' || path.startsWith('/topic/')) return 'talk';
  if (path === '/themes' || path.startsWith('/themes/')) return 'theme';
  if (path === '/requests' || path.startsWith('/requests/')) return 'requests';
  if (path.startsWith('/result/')) return 'result';
  if (path === '/me' || path.startsWith('/me/')) return 'me';
  if (path.startsWith('/p/')) return 'person';
  if (path.startsWith('/places/')) return 'place';
  if (path.startsWith('/e/')) return 'handoff';
  return 'app';
}
